"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _FileManager = _interopRequireDefault(require("composer-lib/components/shared/FileManager"));

var _Drawer = _interopRequireDefault(require("FileManagerLib/components/Drawer"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _userInfo = require("hub-http/userInfo");

var _Constants = require("FileManagerLib/Constants");

var _FileAccess = require("FileManagerLib/enums/FileAccess");

var _hubLVideo = require("FileManagerLib/utils/hubLVideo");

var AddVideoButton = (0, _createReactClass.default)({
  displayName: "AddVideoButton",
  propTypes: {
    fileManagerUploadedFileAccess: _propTypes.default.string.isRequired,
    onChange: _propTypes.default.func.isRequired,
    useUnstyledButton: _propTypes.default.bool.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      open: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var fileManagerUploadedFileAccess = this.props.fileManagerUploadedFileAccess;
    this.FileManager = (0, _FileManager.default)(fileManagerUploadedFileAccess, (0, _UsageTracking.getUsageTracker)());
  },
  handleClick: function handleClick() {
    (0, _UsageTracking.trackEvent)({
      action: 'format-bar-click',
      extra: {
        'click-type': 'video'
      },
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.USAGE
    });
    this.setState({
      open: true
    });
  },
  handleClose: function handleClose(e) {
    if (e) {
      e.stopPropagation();
    }

    this.setState({
      open: false
    });
  },
  handleInsert: function handleInsert(file) {
    var onChange = this.props.onChange;
    this.setState({
      open: false
    });
    onChange({
      playerId: (0, _hubLVideo.getHubLVideoPlayerIdFromFile)(file.toJS()),
      src: file.get('url')
    });
  },
  renderFileManager: function renderFileManager(open) {
    var fileManagerUploadedFileAccess = this.props.fileManagerUploadedFileAccess;

    if (!open) {
      return null;
    }

    var drawerType = fileManagerUploadedFileAccess === _FileAccess.DrawerFileAccess.VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE ? _Constants.DrawerTypes.VIDEO : _Constants.DrawerTypes.HUBL_VIDEO;
    return _react.default.createElement(this.FileManager, {
      auth: (0, _userInfo.userInfoSync)()
    }, _react.default.createElement(_Drawer.default, {
      type: drawerType,
      onSelect: this.handleInsert,
      onClose: this.handleClose
    }));
  },
  renderUnstyledButton: function renderUnstyledButton() {
    var open = this.state.open;

    if (_react.default.Fragment) {
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UIButton.default, {
        className: "video-button",
        onClick: this.handleClick,
        use: "unstyled"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "composer-lib.insertTools.video"
      })), this.renderFileManager(open));
    }

    return _react.default.createElement(_UIButton.default, {
      className: "video-button",
      onClick: this.handleClick
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.insertTools.video"
    }), this.renderFileManager(open));
  },
  render: function render() {
    var useUnstyledButton = this.props.useUnstyledButton;
    var open = this.state.open;

    if (useUnstyledButton) {
      return this.renderUnstyledButton();
    }

    return _react.default.createElement(_UIButton.default, {
      className: "video-button",
      onClick: this.handleClick,
      size: "small",
      use: "unstyled"
    }, _react.default.createElement(_UIIcon.default, {
      name: "insertVideo"
    }), this.renderFileManager(open));
  }
});
var _default = AddVideoButton;
exports.default = _default;
module.exports = exports.default;